import { useView } from '@10000/react'
import { Table } from './table'
import { country as countries, industries, subscriptions } from '../../../lookups'

export const OrganisationTable = () => {
  const { organisations, teams, subscription } = useView('tenant')

  const columns = [
    { key: 'name', name: 'Name' },
    { key: 'country', name: 'Country' },
    { key: 'city', name: 'City' },
    { key: 'industry', name: 'Industry' },
    { key: 'teams', name: 'Teams' }
  ]

  const rows = organisations.map(({ name, city, country, industry, id }) => ({
    name,
    city,
    country: countries?.name[country],
    industry: industries[industry]?.name,
    teams: teams.filter(team => team.organisation === id).length
  }))

  return subscriptions[subscription?.index]?.type === 'partner' && (
    <Table
      title="Organisations"
      rows={rows}
      columns={columns}
      defaultSortColumn="name"
    />
  )
}